<template>
  <div class="product-info-wrapper">
    <div class="banner">
      <div class="cover cover-sqfwpt">
        <div class="cover-text">
          <h4>社区服务平台</h4>
          <p class="info">社区业务管理平台主要应用于互联网环境（支持私有化部署）。通过平台可检测社区前端接入的所有物联网感知设备运行态势，从而达到对小区的全方位把控，社区业务管理平台将感知设备如门禁、视频、物业服务等场景集成统一平台，通过对分散数据的汇聚，为数据服务提供有效支撑。</p>
        </div>
      </div>
    </div>
    <!-- 产品功能 -->
    <div class="product-function">
      <div class="common-title">
        <div class="common-title-content">
          产品功能
        </div>
      </div>
      <div class="product-function-list">
        <div class="item" v-for="(item, index) in funcList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text">{{ item.text }}</div>
        </div>
      </div>
    </div>
    <!-- 产品优势 -->
    <div class="product-advantage product-advantage-blue bg2F61AE">
      <div class="common-title">
        <div class="common-title-content">
          产品优势
        </div>
      </div>
      <div class="content content-blue">
        <div class="circle">
          <div class="badge">
            <img src="@/assets/images/productInfo/sqfwpt/badge.png" />
          </div>
          <div class="feature feature-one">
            <div class="text">小区档案数据化</div>
          </div>
          <div class="feature feature-two">
            <div class="text">社区管理体系化</div>
          </div>
          <div class="feature feature-three">
            <div class="text">治安防控精准化</div>
          </div>
        </div>
      </div>
    </div>
    <!-- 应用场景 -->
    <div class="product-application-scene">
      <div class="common-title">
        <div class="common-title-content">
          应用场景
        </div>
      </div>
      <div class="product-scene-list">
        <div class="item" v-for="(item, index) in sceneList" :key="index">
          <img :src="item.imgUrl" />
          <div class="text" v-html="item.text"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "sqfwpt",
  data() {
    return {
      funcList: [
        {
          imgUrl: require("@/assets/images/productInfo/sqfwpt/ico_sjcj.png"),
          text: "数据采集"
        },
        {
          imgUrl: require("@/assets/images/productInfo/sqfwpt/ico_ywlz.png"),
          text: "业务流转"
        },
        {
          imgUrl: require("@/assets/images/productInfo/sqfwpt/ico_sbgk.png"),
          text: "设备管控"
        },
        {
          imgUrl: require("@/assets/images/productInfo/sqfwpt/ico_jcxxgl.png"),
          text: "基础信息管理"
        }
      ],
      sceneList: [
        {
          imgUrl: require("@/assets/images/productInfo/sqfwpt/wygl.png"),
          text: "物业管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/sqfwpt/xggl.png"),
          text: "巡更管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/sqfwpt/jfgl.png"),
          text: "缴费管理"
        },
        {
          imgUrl: require("@/assets/images/productInfo/sqfwpt/fkgl.png"),
          text: "访客管理"
        }
      ]
    };
  }
};
</script>
